/*
Project : Cryptotrades
FileName :  config.ts
Author : LinkWell
File Created : 21/07/2021
CopyRights : LinkWell
Purpose : This is the file which contain all global constants used in the application
*/
// export const config = {
//     site_name: "NFT",
//     media_path: 'https://moovmintnftapi.stsblockchain.xyz',

//     base_url: "http://localhost:4200",
//     // base_url: 'https://gdcc-nft-user.netlify.app',
//     google_client_id: '463197681074-rt0537fuvclatgjes4mct01gf19ja8ar.apps.googleusercontent.com',
//     facebook_client_id: '370223044026040',
//     blockchain: "Polygon Testnet",
//     blockchain_url: "https://mumbai.polygonscan.com/",
//     onboard: {
//         key: 'b9c4f15a-de2e-440b-97a0-7925abab9353',
//         network: 6796,
//         networkid: '0x1A8C',
//         curreency: 'MATIC',
//         decimal: 18,
//         rpc: 'https://data-seed1.gdccoin.io',
//         blockurl: 'https://testnet.gdcscan.io'
//     },
//     main_address: "0xaCeEF0453dE61B48CF0159749f192F5fc6a77298",
//     multi_contract_address: "0xc09e5d75d6bdc948286C26d4D0eE428bD613E2eE"
// }

export const config = {
    site_name: "GDCC NFT",
    media_path: 'https://gdccnft.stsblockchain.xyz',
    // media_path: 'https://testnetapi.muzella.studio',
   // base_url: "http://localhost:4200",
    base_url: 'https://gdcc-nft-user.netlify.app',
    google_client_id: '463197681074-rt0537fuvclatgjes4mct01gf19ja8ar.apps.googleusercontent.com',
    facebook_client_id: '370223044026040',
    blockchain: "GDCC",
    blockchain_url: "https://testnet.gdcscan.io/",
    onboard: {
        key: 'b9c4f15a-de2e-440b-97a0-7925abab9353',
        network: 6796,
        networkid: '0x1A8C',
        curreency: 'GDCC',
        decimal: 18,
        rpc: 'https://data-seed1.gdccoin.io',
        blockurl: 'https://testnet.gdcscan.io/'
    },
    main_address: "0x49705D7A5821932d0B12FCacDdE10FF608616d70",
    multi_contract_address: "0xD8264ac5ff3D14c99063584Bbdf00671fe9c5278"
}
